import Backbone from 'backbone';

export default Backbone.Model.extend({
  defaults: {
    id: '',
    label: '',
    open: true,
    attributes: {}
  }
});



// WEBPACK FOOTER //
// webpack://grapesjs/src/block_manager/model/Category.js